<template>
  <div v-if="profiles.length > 0" class="row pt-3 shadow">
    <div class="border rounded shadow card col-12 border-0 p-0">
      <div class="card-header bg-primary text-white">
        Interessante Mitglieder
      </div>
      <div class="row pr-3 pl-3 pt-1 pt-0">
        <div
          class="col-12 pb-1"
          v-for="(profile, index) in profiles"
          :key="index"
        >
          <image-profile-box :profile="profile"></image-profile-box>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    if (this.$store.getters["user/auth"]) {
      this.$store.dispatch("search/proposals");
    }
  },
  computed: {
    profiles() {
      return this.$store.getters["search/proposed"];
    }
  }
};
</script>
